// extracted by mini-css-extract-plugin
export var askAiIcon = "_pj-9";
export var container = "_pj-0";
export var groupSeparator = "_pj-a";
export var highlight = "_pj-4";
export var resultIcon = "_pj-5";
export var resultItem = "_pj-7";
export var resultSubtitle = "_pj-3";
export var resultTitle = "_pj-2";
export var resultsList = "_pj-1";
export var searchGroup = "_pj-6";
export var selected = "_pj-8";